import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import {
  ControlsIcon,
  ExpandedHeaderContainer,
  Filler,
  FirstRow,
  FirstRowAction,
  FirstRowControls,
  FirstRowTitle,
  SecondRow,
  SecondRowAction,
  SecondRowControls,
  SecondRowTitle,
  Button,
  ControlSvgIcon
} from "./style";
import { TopBar } from "../../setting/components/topbar";
import EventListener from "react-event-listener";
import Back from "../../../components/back";
import makeSafeToUseInDangerousInnerHtml from "../../../lib/makeSafeToUseInDangerousInnerHtml";

/**
  `<ExpandedHeader
    title= "your title <span>sth that has primary color</span>"
    description= "your description"
    controls={[
        {
          title: 'your-title',
          icon: 'icon-name',
          onclick: () => yourMethod()
        }
      ]}
    >
      <YourComponent/> // show under the title
    </ExpandedHeader>
 * */

class ExpandedHeader extends Component {
  constructor(props) {
    super(props);
    this.state = {
      hideTopBar: false
    };
    this.previousPath = this.props.history.location.state
      ? this.props.history.location.state.from
      : undefined;
    this.onScroll = this.onScroll.bind(this);
  }
  onScroll() {
    const { hideTopBar } = this.state;
    let offsetTop = this.instance.getBoundingClientRect().top;
    if (parseInt(offsetTop) < 44) {
      if (!hideTopBar) {
        this.setState({ hideTopBar: true });
      }
    } else {
      if (hideTopBar) {
        this.setState({ hideTopBar: false });
      }
    }
  }
  render() {
    const { hideTopBar } = this.state;
    const controls =
      this.props.controls && this.props.controls.filter(item => !item.disabled);
    return (
      <React.Fragment>
        <EventListener target="document" onScroll={this.onScroll} />
        <ExpandedHeaderContainer ref={el => (this.instance = el)}>
          {!hideTopBar && <TopBar noShadow noBack noBorder />}

          <FirstRow fixed={hideTopBar}>
            <div className="container">
              {hideTopBar && <Back noLabel backTo={this.previousPath} />}
              <FirstRowTitle
                status={hideTopBar}
                dangerouslySetInnerHTML={{ __html: this.props.title || "" }}
              />
              <FirstRowAction status={hideTopBar}>
                {this.props.children || ""}
              </FirstRowAction>
              <FirstRowControls status={hideTopBar}>
                {controls &&
                  controls.map((control, key) => {
                    if (control.isButton) {
                      return (
                        <Button key={key} onClick={() => control.onClick()}>
                          <i className={`icon ${control.icon}`} />
                          <span
                            dangerouslySetInnerHTML={{
                              __html: makeSafeToUseInDangerousInnerHtml(
                                control.title
                              )
                            }}
                          />
                          {control.child}
                        </Button>
                      );
                    } else if (control.svgIcon) {
                      return (
                        <ControlSvgIcon
                          key={key}
                          title={control.title || ""}
                          onClick={() => control.onClick()}
                        >
                          <control.svgIcon />
                          {control.child}
                        </ControlSvgIcon>
                      );
                    } else {
                      return (
                        <ControlsIcon
                          key={key}
                          title={control.title || ""}
                          className={`icon ${control.icon}`}
                          onClick={() => control.onClick()}
                        >
                          {control.child}
                        </ControlsIcon>
                      );
                    }
                  })}
              </FirstRowControls>
            </div>
          </FirstRow>

          {!hideTopBar && (
            <SecondRow>
              <div className="container">
                <div className="back-container">
                  <Back noLabel backTo={this.previousPath} />
                </div>
                {this.props.title && (
                  <SecondRowTitle
                    className={"test"}
                    status={hideTopBar}
                    dangerouslySetInnerHTML={{ __html: this.props.title || "" }}
                  />
                )}
                {this.props.description && (
                  <div
                    className="description"
                    title={this.props.description || ""}
                  >
                    {this.props.description || ""}
                  </div>
                )}
                {controls && (
                  <SecondRowControls status={hideTopBar}>
                    {controls &&
                      controls.map((control, key) => {
                        if (control.isButton) {
                          return (
                            <Button key={key} onClick={() => control.onClick()}>
                              <i className={`icon ${control.icon}`} />
                              <span
                                dangerouslySetInnerHTML={{
                                  __html: makeSafeToUseInDangerousInnerHtml(
                                    control.title
                                  )
                                }}
                              />
                              {control.child}
                            </Button>
                          );
                        } else if (control.svgIcon) {
                          return (
                            <ControlSvgIcon
                              key={key}
                              title={control.title || ""}
                              onClick={() => control.onClick()}
                            >
                              <control.svgIcon />
                              {control.child}
                            </ControlSvgIcon>
                          );
                        } else {
                          return (
                            <ControlsIcon
                              key={key}
                              title={control.title || ""}
                              className={`icon ${control.icon}`}
                              onClick={
                                control.disabled
                                  ? () => false
                                  : () => control.onClick()
                              }
                            >
                              {control.child}
                            </ControlsIcon>
                          );
                        }
                      })}
                  </SecondRowControls>
                )}
              </div>
              {this.props.children && (
                <div className="container-2">
                  <SecondRowAction status={hideTopBar}>
                    {this.props.children || ""}
                  </SecondRowAction>
                </div>
              )}
            </SecondRow>
          )}
          {hideTopBar && <Filler />}
        </ExpandedHeaderContainer>
      </React.Fragment>
    );
  }
}

export default withRouter(ExpandedHeader);
